export const WZ = window.IWangZhe
export const WZUtils = WZ.Utils

export const WZServices = window.WZServices

export const {
  getServerTime,
  getErrorMsg,
  setErrorMsg,
  inMobile,
  inApp,
  inWZApp,
  inXSApp,
  inDKApp,
  inWeiXin,
  isXSWeb,
  inMQQ,
  inIOS,
  inAndroid,
  inWxMp,
  inEnvDev
} = WZUtils
